import {
    CORE_CREATE_AMENITY_SUCCESS,
    CORE_CREATE_AMENITY_REQUEST,

    CORE_EDIT_AMENITY_SUCCESS,
    CORE_EDIT_AMENITY_REQUEST,

    CORE_LOAD_ALL_AMENITY_SUCCESS,
    CORE_LOAD_ALL_AMENITY_REQUEST,

    CORE_LOAD_AMENITY_SUCCESS,
    CORE_LOAD_AMENITY_REQUEST,

    CORE_DELETE_AMENITY_SUCCESS,
    CORE_DELETE_AMENITY_REQUEST,

    CORE_FILTER_AMENITY_SUCCESS,
    CORE_FILTER_AMENITY_REQUEST
} from '../../types'

const initialState = []
export default {
    amenity: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_AMENITY_REQUEST:
            case CORE_LOAD_AMENITY_REQUEST:
            case CORE_EDIT_AMENITY_REQUEST:
            case CORE_DELETE_AMENITY_REQUEST:
                return initialState

            case CORE_CREATE_AMENITY_SUCCESS:
            case CORE_LOAD_AMENITY_SUCCESS:
            case CORE_EDIT_AMENITY_SUCCESS:
            case CORE_DELETE_AMENITY_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
    amenityList:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_AMENITY_REQUEST:
            case CORE_FILTER_AMENITY_REQUEST:
                return initialState

            case CORE_LOAD_ALL_AMENITY_SUCCESS:
            case CORE_FILTER_AMENITY_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/amenity/reducer.js